export const TYPE = {
  CREATED: 1, // criado
  SUSTEINED: 2, // mantido
  SUSPENDED: 3, // suspenso
  CHANGED: 4, // modificado
  GIVEN_DEADLINE: 5, // aprazado
  CHANGED_PERIOD: 6 // período modificado
};
